import React from 'react'

import AdvisorComp, {
  AdvisorProps,
} from '@ampdx/component-library/src/components/Advisor/src/Advisor'

const Advisor = ({ content }: AdvisorProps) => {
  return <AdvisorComp content={content} />
}

export default Advisor
